import * as React from 'react';

const LoadingIcon = () => {
  return (
    <div className="loading-icon" style={{ textAlign: 'center', marginTop: '20px' }}>
      <div
        style={{
          width: '40px',
          height: '40px',
          border: '4px solid #fff',
          borderTop: '4px solid #BBDCD5',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto',
        }}
      />

      <style>
        {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
      </style>
    </div>
  );
};

export default LoadingIcon;
